/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'close-big': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<g fill-rule="evenodd"><path pid="0" d="M12 22.667c5.891 0 10.667-4.776 10.667-10.667S17.89 1.333 12 1.333 1.333 6.11 1.333 12 6.11 22.667 12 22.667zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z" fill-rule="nonzero"/><path pid="1" d="M12.01 11.012l3.787-3.786.987.988L12.998 12l3.786 3.786-.987.988-3.786-3.786-3.787 3.786-.987-.988L11.023 12 7.237 8.214l.987-.988 3.787 3.786z"/></g>'
  }
})
